import Api from ".";
import { BaseFilter, Entity } from "../models";
import { ISerializable } from "../models/Entity";
import { toOptionalObject } from "./core/optional";

export type CrudApiSettings<TEntity extends Entity & ISerializable> = {
    endpoint: string;
    defaultFields?: string;
    serialize?: (e: Partial<TEntity>) => any;
    parse: (e: any) => TEntity;
}

export default class CrudApi<TEntity extends Entity & ISerializable> {
    constructor(protected baseApi: Api, protected settings: CrudApiSettings<TEntity>) {
    }

    create<T = string>(e: TEntity, parse?: (json: any) => T) {
        return this.baseApi.post<T>(`${this.settings.endpoint}`, this.settings.serialize ? this.settings.serialize(e) : e.toJson(), parse);
    }
    fetch = <TFilter extends BaseFilter<TEntity> = BaseFilter<TEntity>>(fields?: string, filter?: TFilter) => this.baseApi.getList<TEntity, TFilter>(`${this.settings.endpoint}`, fields ?? this.settings.defaultFields, filter as any,
        (json: any) => ({
            filter: new BaseFilter<TEntity>(json.filter) as TFilter,
            items: json.items.map((e: any) => this.settings.parse(e)) as TEntity[],
        }));
    fetchItem = (id: string, fields?: string) => this.baseApi.get<TEntity>(`${this.settings.endpoint}/${id}`, fields ?? this.settings.defaultFields, this.settings.parse);
    save(e: Partial<TEntity> & Pick<TEntity, 'id'>) {
        return this.baseApi.put(`${this.settings.endpoint}`, this.settings.serialize ? this.settings.serialize(e) : { ...toOptionalObject({ ...e }), id: e.id });
    }
    delete<T = void>(id: string, parse?: (json: any) => T) {
        return this.baseApi.delete(`${this.settings.endpoint}/${id}`, parse);
    }
}
